// Shared date/time formatting helpers.

// fmtTs(iso): "2026-06-05 15:24 EDT" — browser-local TZ + short abbreviation.
// The full ISO string is preserved in the caller's `title` attribute so hover
// reveals the canonical UTC value.
export function fmtTs(iso) {
  if (!iso) return "-";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  const pad = (n) => String(n).padStart(2, "0");
  const date = d.getFullYear() + "-" + pad(d.getMonth() + 1) + "-" + pad(d.getDate());
  const time = pad(d.getHours()) + ":" + pad(d.getMinutes());
  const parts = d.toLocaleTimeString("en-US", { timeZoneName: "short" }).split(" ");
  const tz = parts[parts.length - 1];
  return `${date} ${time} ${tz}`;
}

// fmtTime(iso): "15:24:07 EDT" — wall-clock only (no date), with TZ.
export function fmtTime(iso) {
  if (!iso) return "-";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  const pad = (n) => String(n).padStart(2, "0");
  const time = pad(d.getHours()) + ":" + pad(d.getMinutes()) + ":" + pad(d.getSeconds());
  const parts = d.toLocaleTimeString("en-US", { timeZoneName: "short" }).split(" ");
  const tz = parts[parts.length - 1];
  return `${time} ${tz}`;
}

// fmtDate(iso): "2026-06-05" — date only, browser-local TZ.
export function fmtDate(iso) {
  if (!iso) return "-";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  const pad = (n) => String(n).padStart(2, "0");
  return d.getFullYear() + "-" + pad(d.getMonth() + 1) + "-" + pad(d.getDate());
}
